<template>
  <div>
    <div class="modal fade" id="viewItem">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              View:
              <span class="text-dark text-truncate">
                {{ selectedTypeName }}
              </span>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- .modal-header -->
          <div class="modal-body">
            <div class="py-3 text-wrap">
              <span class="mr-1 h5">OLAB ID:</span>
              <span class="ml-1 h5">{{ item.olab_id }}</span>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <span class="mr-1">Media ID:</span>
                <span class="ml-1">{{ item.media_id }}</span>
              </div>
              <div class="form-group col-md-6">
                <span class="mr-1">Strain ID:</span>
                <span class="ml-1">{{ item.strain_id }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <span class="mr-1">Start Time:</span>
                <span class="ml-1">{{ item.start_time }}</span>
              </div>
              <div class="form-group col-md-4">
                <span class="mr-1">End Time:</span>
                <span class="ml-1">{{ item.end_time }}</span>
              </div>
              <div class="form-group col-md-4">
                <span class="mr-1">Culture Time:</span>
                <span class="ml-1">{{ item.culture_time }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <span class="mr-1">Incubator:</span>
                <span class="ml-1">{{ item.incubator }}</span>
              </div>
              <div class="form-group col-md-6">
                <span class="mr-1">Temperature:</span>
                <span class="ml-1">{{ item.temperature }} &#8451;</span>
              </div>
            </div>
            <div class="form-group">
              <span class="mr-1">Growth:</span>
              <span class="ml-1">{{ item.growth }}</span>
            </div>
            <div class="form-group">
              <span class="mr-1">Note:</span>
              <span class="ml-1">{{ item.note }}</span>
            </div>
          </div>
          <!-- .modal-body -->

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
          <!-- .modal-footer -->
        </div>
        <!-- .modal-content -->
      </div>
      <!-- .modal-dialog .modal-lg-->
    </div>
  </div>
</template>

<script>
export default {
  name: "plateviewform",
  data() {
    return {
      selectedType: "plate",
      selectedTypeName: "Plate",
      item: {
        olab_id: "PLT-000001",
        media_id: "MD-0001",
        strain_id: "STN-0001",
        start_time: "01:00:00",
        end_time: "02:00:00",
        culture_time: "01:00:00",
        incubator: "Incubator 1",
        temperature: 37.0,
        temperature_unit: "C",
        growth: "TO DO",
        note: "Note section"
      }
    };
  },
  props: ["statusObj", "errorObj"],
  emits: ["emitStatusMessage", "emitErrorMessage"],
  mounted() {
    console.log("PlateViewForm mounted ...");
    // Reset status and error
    this.doEmitStatusMessage(null, false);
    this.doEmitErrorMessage(null);
  },
  methods: {
    doEmitStatusMessage(statusMsg, statusProgress) {
      this.$emit("emitStatusMessage", statusMsg, statusProgress);
    },
    doEmitErrorMessage(errMsg) {
      this.$emit("emitErrorMessage", errMsg);
    },
    closeStatus() {
      // console.log("Close Status Alert ...");
      this.emitStatusMessage(null, false);
    },
    closeError() {
      // console.log("Close Error Alert ...");
      this.emitErrorMessage(null);
    }
  }
};
</script>
